module.exports = __webpack_public_path__ + "img/10.a197f12f.png";